// extracted by mini-css-extract-plugin
module.exports = {"main":"loginPage_main__1_E5_"};